var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3443_61889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.2969C14.7426 17.2969 15.75 16.2895 15.75 15.0469C15.75 13.8042 14.7426 12.7969 13.5 12.7969C12.2574 12.7969 11.25 13.8042 11.25 15.0469C11.25 16.2895 12.2574 17.2969 13.5 17.2969Z",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.79688C14.7426 6.79688 15.75 5.78952 15.75 4.54688C15.75 3.30423 14.7426 2.29688 13.5 2.29688C12.2574 2.29688 11.25 3.30423 11.25 4.54688C11.25 5.78952 12.2574 6.79688 13.5 6.79688Z",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.0469C5.74264 12.0469 6.75 11.0395 6.75 9.79688C6.75 8.55423 5.74264 7.54688 4.5 7.54688C3.25736 7.54688 2.25 8.55423 2.25 9.79688C2.25 11.0395 3.25736 12.0469 4.5 12.0469Z",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.625 5.67188L6.375 8.67188",
    stroke: "#2E4D6B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.375 10.9219L11.625 13.9219",
    stroke: "#2E4D6B",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3443_61889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.796875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareAndroid);
export default __webpack_public_path__ + "static/media/share-android.5262367e0cfffa63cc8005e24b978285.svg";
export { ForwardRef as ReactComponent };